<template>
    <div id="card-battle-game" class="card fade-down card-event-alert mb-4">
        <div class="card-body">
            <div class="card-content d-flex justify-content-end text-white">
                <div class="d-flex flex-column justify-content-between gap-3 w-50 ps-3 ">
                    <div class="card-battle-game-header d-flex flex-column">
                        <div class="d-flex gap-3">
                            <h3>{{ events.name }}</h3>
                        </div>
                        <p class="desc mb-2">{{ $t('from') }} {{ events.start_time }} {{ $t('to') }} {{ events.end_time }}</p>
                    </div>

                    <div class="d-flex justify-content-end align-items-end align-items-center gap-3">
                        <div class="d-flex flex-column gap-1 align-items-center" v-if="events.is_start || events.time_remaining <= 0">
                            <template v-if="events.is_start">
                                <div class="playing"><i class="ito-icon ito-user"></i>{{ events.number_playing }}</div>
                                <p class="text-nowrap">{{ $t('student_playing') }}</p>
                            </template>
                            <template v-else-if="events.time_remaining <= 0">
                            </template>
                        </div>
                        <h3 class="d-flex gap-1 align-items-center" v-else><i class="ito-icon-clock-wise"></i><span v-html="timeLeft"></span></h3>
                        <router-link class="ito-btn ito-btn-primary" :to="{ name: 'events' }">
                            {{ $t('view_event') }}
                        </router-link>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
var counter;

export default {
    name: "BattleGameBanner",
    props: ['events'],
    data() {
        return {
            timeLeft: '00:00:00'
        }
    },
    mounted() {
        const that = this;
        if (that.events.time_remaining > 0) {
            that.timerCountdown(1729765523);
            console.log(that.timeLeft);
        }
    },
    methods: {
        timerCountdown(time_remaining) {
            const self = this;
            counter = new Counter(time_remaining + 1, 1000);
            counter.onTick(function (time) {
                self.timeLeft = time.hour + ':' + time.minute + ':' + time.second
            });
            counter.onEnd(function () {
                window.location.reload();

            })
            counter.start();
        },
    }
}
</script>
<style scoped>
#card-battle-game .card-content {
    background-image: url('/public/themes/ito/images/battlegame/Battlegame_bg.png');
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
    padding: 12px 20px;
    min-height: 156px;
}

#card-battle-game .card-battle-game-header h3 {
    font-size: 24px;
    font-weight: 700;
    text-align: left;
}

#card-battle-game .card-battle-game-header .playing {
    display: flex;
    align-items: center;
    font-size: 20px;
    font-weight: 700;
    text-align: left;
    color: var(--primary);
}
</style>